import { render, staticRenderFns } from "./AttachmentPanel.vue?vue&type=template&id=f3bb0c3a"
import script from "./AttachmentPanel.vue?vue&type=script&lang=js"
export * from "./AttachmentPanel.vue?vue&type=script&lang=js"
import style0 from "./AttachmentPanel.vue?vue&type=style&index=0&id=f3bb0c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports